import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import FormFlagIssues, { FlagIssuesFormData } from 'dashboard/forms/FormFlagIssues';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { ReportIssueResponseType } from 'dashboard/lib/constants/reportIssue';
import { Document } from 'dashboard/models/document';
import { Verification } from 'dashboard/models/verification';

interface FlagIssuesModalProps {
  verifications: Verification[];
  documents: Document[];
  handleClose: () => void;
  handleSubmitFlagIssues: (values: FlagIssuesFormData) => Promise<void>;
}

const ModalDescriptionContainer = styled('div')`
  margin-bottom: ${SPACINGS.base * 2}px;
`;

const FlagIssuesModal = ({
  verifications,
  documents,
  handleClose,
  handleSubmitFlagIssues,
}: FlagIssuesModalProps) => {
  // TODO: cleanup dashboard:new-flag-issues, migrate to flag-issues
  return (
    <ModalContainer size='xl' data-test='report-issue-modal'>
      <ModalHeader data-test='report-issue-modal__header' onClose={handleClose}>
        Flag an issue
      </ModalHeader>
      <ModalBody>
        <ModalDescriptionContainer>
          If you see an issue with this inquiry, you can report it to our QA team for review.
        </ModalDescriptionContainer>
        <FormFlagIssues
          onSubmit={handleSubmitFlagIssues}
          handleCancel={handleClose}
          initialValues={{
            responseType: ReportIssueResponseType.NotRequired,
          }}
          verifications={verifications}
          documents={documents}
        />
      </ModalBody>
    </ModalContainer>
  );
};

export default FlagIssuesModal;
